import { useEffect } from "react"
import { useSessionStore } from "@/store/sessionStore"
import { selectConnectionFailed, selectError } from "@/store/selectors"
import styles from "@/styles/components/ErrorToast.module.css"

/** How long a failed write stays on screen before it stops being useful. */
const DISMISS_AFTER_MS = 7000

/**
 * Shows write errors globally.
 * Connection errors are handled by the session screen.
 * The message clears automatically after a short delay.
 */

export default function ErrorToast() {
  const error = useSessionStore(selectError)
  const connectionFailed = useSessionStore(selectConnectionFailed)
  const setError = useSessionStore((s) => s.setError)

  useEffect(() => {
    if (error === null || connectionFailed) return
    const timer = setTimeout(() => setError(null), DISMISS_AFTER_MS)
    return () => clearTimeout(timer)
  }, [error, connectionFailed, setError])

  if (error === null || connectionFailed) return null

  return (
    <div className={styles.toast} role="alert">
      <p className={styles.message}>{error}</p>
      <button
        type="button"
        className={styles.dismiss}
        onClick={() => setError(null)}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  )
}
